export default "__VITE_ASSET__8d519dd7__"